import axios from 'axios';


const API_URL = `${process.env.REACT_APP_BACKEND_URL || 'http://localhost:8081'}/api/management/customers`;




  export const updateCustomerById = async (customerId, data) => {
    console.log("Actualizando cliente con ID:", customerId, "con datos:", data);
    try {
      // The backend identifies the admin (slot audit log, enabledSlots guard) from this token.
      // Plain axios on purpose: nodeBackApi logs the user out on 403, and a 403 here only means "not admin".
      const token = localStorage.getItem('authLisualToken');
      const response = await axios.put(`${API_URL}/${customerId}`, data, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      return response.data;
    } catch (error) {
      console.error("Error al actualizar el cliente:", error);
      throw error;
    }
  };



  export const getAllCustomers = async () => {
    try {
      const response = await axios.get(API_URL);
      return response.data;
    } catch (error) {
      console.error("Error al obtener los clientes:", error);
      throw error;
    }
  };


